import { render, staticRenderFns } from "./TheTicket.vue?vue&type=template&id=04440650&scoped=true"
import script from "./TheTicket.vue?vue&type=script&lang=js"
export * from "./TheTicket.vue?vue&type=script&lang=js"
import style0 from "./TheTicket.vue?vue&type=style&index=0&id=04440650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04440650",
  null
  
)

export default component.exports